import React, { useState, useEffect } from "react";
import { Button, Col, Row, Modal, Form, Image } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";
// import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
// import { HoursofItemAvailability } from "../../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/BusinessHoursMultiplePopup";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
//import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { get_category_menu_setup } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import FastFoodMenuSetupItem from "./FastFoodMenuSetupItem";
import { SET_ACTIVE_CATEGORY_DATA_MENU_SETUP } from "../../../../../../../store/types";
import { useHistory } from "react-router-dom";

const FastFoodMenuSetup = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  //state
  const [showChain, setShowChain] = useState(false);
  const [showGloble, setShowGloble] = useState(false);
  // const [showSubCategory, setShowSubCategory] = useState(false);
  // const [showEditSubCategory, setShowEditSubCategory] = useState(false);
  // const [state, setState] = useState({
  //   code: "",
  //   country: "",
  //   state: "",
  //   role: "",
  //   monday: {
  //     open: false,
  //     breakfast: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 10),
  //       closing_time: new Date(2020, 1, 1, 12),
  //     },
  //     lunch: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 13),
  //       closing_time: new Date(2020, 1, 1, 16),
  //     },
  //     dinner: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 19),
  //       closing_time: new Date(2020, 1, 1, 22),
  //     },
  //     multipleHours: [
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 10),
  //         closing_time: new Date(2020, 1, 1, 12),
  //         description: "Breakfast",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 13),
  //         closing_time: new Date(2020, 1, 1, 16),
  //         description: "Lunch",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 19),
  //         closing_time: new Date(2020, 1, 1, 22),
  //         description: "Dinner",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 24),
  //         closing_time: new Date(2020, 1, 1, 4),
  //         description: "Midnight Munching",
  //       },
  //     ],
  //   },
  //   tuesday: {
  //     open: false,
  //     breakfast: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 8),
  //       closing_time: new Date(2020, 1, 1, 11),
  //     },
  //     lunch: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 13),
  //       closing_time: new Date(2020, 1, 1, 15),
  //     },
  //     dinner: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 17),
  //       closing_time: new Date(2020, 1, 1, 23),
  //     },
  //     multipleHours: [
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 8),
  //         closing_time: new Date(2020, 1, 1, 11),
  //         description: "Breakfast",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 13),
  //         closing_time: new Date(2020, 1, 1, 15),
  //         description: "Lunch",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 17),
  //         closing_time: new Date(2020, 1, 1, 23),
  //         description: "Dinner",
  //       },
  //     ],
  //   },
  //   wednesday: {
  //     open: false,
  //     breakfast: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 8),
  //       closing_time: new Date(2020, 1, 1, 11),
  //     },
  //     lunch: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 13),
  //       closing_time: new Date(2020, 1, 1, 15),
  //     },
  //     dinner: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 17),
  //       closing_time: new Date(2020, 1, 1, 23),
  //     },
  //     multipleHours: [
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 8),
  //         closing_time: new Date(2020, 1, 1, 11),
  //         description: "Breakfast",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 13),
  //         closing_time: new Date(2020, 1, 1, 15),
  //         description: "Lunch",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 17),
  //         closing_time: new Date(2020, 1, 1, 23),
  //         description: "Dinner",
  //       },
  //     ],
  //   },
  //   thursday: {
  //     open: false,
  //     breakfast: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 8),
  //       closing_time: new Date(2020, 1, 1, 11),
  //     },
  //     lunch: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 13),
  //       closing_time: new Date(2020, 1, 1, 15),
  //     },
  //     dinner: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 17),
  //       closing_time: new Date(2020, 1, 1, 23),
  //     },
  //     multipleHours: [
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 8),
  //         closing_time: new Date(2020, 1, 1, 11),
  //         description: "Breakfast",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 13),
  //         closing_time: new Date(2020, 1, 1, 15),
  //         description: "Lunch",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 17),
  //         closing_time: new Date(2020, 1, 1, 23),
  //         description: "Dinner",
  //       },
  //     ],
  //   },
  //   friday: {
  //     open: false,
  //     breakfast: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 8),
  //       closing_time: new Date(2020, 1, 1, 11),
  //     },
  //     lunch: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 13),
  //       closing_time: new Date(2020, 1, 1, 15),
  //     },
  //     dinner: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 17),
  //       closing_time: new Date(2020, 1, 1, 23),
  //     },
  //     multipleHours: [
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 8),
  //         closing_time: new Date(2020, 1, 1, 11),
  //         description: "Breakfast",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 13),
  //         closing_time: new Date(2020, 1, 1, 15),
  //         description: "Lunch",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 17),
  //         closing_time: new Date(2020, 1, 1, 23),
  //         description: "Dinner",
  //       },
  //     ],
  //   },
  //   saturday: {
  //     open: false,
  //     breakfast: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 8),
  //       closing_time: new Date(2020, 1, 1, 11),
  //     },
  //     lunch: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 13),
  //       closing_time: new Date(2020, 1, 1, 15),
  //     },
  //     dinner: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 17),
  //       closing_time: new Date(2020, 1, 1, 23),
  //     },
  //     multipleHours: [
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 8),
  //         closing_time: new Date(2020, 1, 1, 11),
  //         description: "Breakfast",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 13),
  //         closing_time: new Date(2020, 1, 1, 15),
  //         description: "Lunch",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 17),
  //         closing_time: new Date(2020, 1, 1, 23),
  //         description: "Dinner",
  //       },
  //     ],
  //   },
  //   sunday: {
  //     open: false,
  //     breakfast: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 8),
  //       closing_time: new Date(2020, 1, 1, 11),
  //     },
  //     lunch: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 13),
  //       closing_time: new Date(2020, 1, 1, 15),
  //     },
  //     dinner: {
  //       open: false,
  //       opening_time: new Date(2020, 1, 1, 17),
  //       closing_time: new Date(2020, 1, 1, 23),
  //     },
  //     multipleHours: [
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 8),
  //         closing_time: new Date(2020, 1, 1, 11),
  //         description: "Breakfast",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 13),
  //         closing_time: new Date(2020, 1, 1, 15),
  //         description: "Lunch",
  //       },
  //       {
  //         open: true,
  //         opening_time: new Date(2020, 1, 1, 17),
  //         closing_time: new Date(2020, 1, 1, 23),
  //         description: "Dinner",
  //       },
  //     ],
  //   },
  // });
  const handleShowChain = () => setShowChain(true);
  const handleCloseChain = () => setShowChain(false);
  const handleShowGloble = () => setShowGloble(true);
  const handleCloseGloble = () => setShowGloble(false);

  const takeToCategoryEditPage = (data) => {
    dispatch({ type: SET_ACTIVE_CATEGORY_DATA_MENU_SETUP, payload: "" });
    history.push(
      props.history.location.pathname.includes("admin")
        ? "/admin-fastfood/menusetup/addcategory"
        : "/fastfood/menusetup/addcategory"
    );
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token);
  }, []);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
              >
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={
                      props.history.location.pathname.includes("admin")
                        ? "/admin-edit-add-subscription"
                        : "/subscription"
                    }
                  />
                </div>
                <div className="onboarding_process_screen-button-map d-flex justify-content-between flex-column">
                  <Row className="align-items-center justify-content-between py-4">
                    <Col md={12} className="pb-4">
                      <TopTextReusableComponent
                        headingText="Menu Set Up"
                        headingParagraph="Manage your food items"
                      />
                    </Col>
                    <Col md={4}>
                      <Button
                        variant="danger"
                        className="btn-md btnf12_400_HelveticaNeue"
                        onClick={handleShowGloble}
                      >
                        Select Categories
                        <br />
                        From Global Menu
                      </Button>
                    </Col>
                    <Col md={4}>
                      <Button
                        className="btn-md btnf12_400_HelveticaNeue btn btn-outline-danger"
                        onClick={() => takeToCategoryEditPage()}
                      >
                        Add Custom
                        <br />
                        Categories
                      </Button>
                    </Col>
                    <Col md={4}>
                      <Button
                        variant="outline-danger"
                        className="btn-md btnf12_400_HelveticaNeue"
                        onClick={handleShowChain}
                      >
                        Add From Chain
                        <br />
                        Categories
                      </Button>
                    </Col>
                  </Row>
                  <div className="f12-500 pb-4">
                    Add all your Menu Categories to move ahead with the Menu Set
                    Up Process
                  </div>
                  <div className="d-flex justify-content-end">
                    <NavLink
                      to="/fastfood/menusetup/crossselling"
                      className="btn-xs btn btn-danger text-normal"
                    >
                      Cross-Selling
                    </NavLink>
                  </div>
                  {props &&
                    props.menuCategory &&
                    props.menuCategory.map((category, index) => (
                      <FastFoodMenuSetupItem key={index} category={category} />
                    ))}

                  <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                    <div>
                      <ReusableOnboardingLink
                        buttonTitle="Back Button"
                        buttonClass="btn-lg btn btn-outline-secondary"
                        buttonText="Cancel"
                        link={
                          props.history.location.pathname.includes("admin")
                            ? "/admin-edit-add-subscription"
                            : "/subscription"
                        }
                      />
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                        buttonText="Set Up Done"
                        buttonType="Submit"
                      />
                    </div>
                    <div className="d-flex justify-content-end ml-5">
                      <NavLink
                        to="/fastfood/menusetup/uploadmenu"
                        className="f12-700 text-red cursor p-0 bg-transparent border-0"
                      >
                        Upload Menu
                      </NavLink>
                      <span className="f10-400 ml-2">
                        Leave Rest to us
                        <br />
                        Charges May Apply
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  // displayBarButton={false}
                  displayHamburger={true}
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
                />
              </div>
            </div>
          </div>

          <Modal
            show={showGloble}
            onHide={handleCloseGloble}
            centered
            className="xl-width-750"
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div className="w-100">
                <Modal.Title className="f20-700 pb-2">
                  Global Catalogue
                </Modal.Title>
                <div className="d-flex justify-content-between">
                  <p className="f14-400">
                    Please select the catalogue menu you want to proceed with
                  </p>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    className="amSearch"
                    style={{ width: 180, backgroundColor: "#fff" }}
                  />
                </div>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4">
              <div className="enGlobleCatelogueModalListMain">
                <Scrollbars style={{ width: "100%", height: 280 }}>
                  <div className="d-flex align-items-center mb-4">
                    <Form.Check label="1" inline className="enCheckBoxOnly" />
                    <div className="enGlobleCatelogueModalList d-flex align-items-center justify-content-between w-100">
                      <div className="d-flex align-items-center">
                        <div className="enCatelogueIconDiv">
                          <SVG
                            width="27px"
                            src={require("../../../../../../../assets/images/UserManagement/menuicon.svg")}
                          />
                        </div>
                        <div className="f14-500 px-3">Catalogue Menu 1</div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="f14-500 pr-3">ID : #001</div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <Form.Check label="1" inline className="enCheckBoxOnly" />
                    <div className="enGlobleCatelogueModalList d-flex align-items-center justify-content-between w-100">
                      <div className="d-flex align-items-center">
                        <div className="enCatelogueIconDiv">
                          <SVG
                            width="27px"
                            src={require("../../../../../../../assets/images/UserManagement/menuicon.svg")}
                          />
                        </div>
                        <div className="f14-500 px-3">Catalogue Menu 1</div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="f14-500 pr-3">ID : #001</div>
                      </div>
                    </div>
                  </div>
                </Scrollbars>
              </div>
              <div className="d-flex align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                >
                  Cancel
                </Button>
                <Button variant="danger" className="btn150px btn-lg px-5">
                  Proceed
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={showChain}
            onHide={handleCloseChain}
            centered
            className="xl-width-750"
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div className="w-100">
                <Modal.Title className="f20-700 pb-2">
                  Chain Catalogue
                </Modal.Title>
                <div className="d-flex justify-content-between">
                  <p className="f14-400">
                    Please select the catalogue menu you want to proceed with
                  </p>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    className="amSearch"
                    style={{ width: 180, backgroundColor: "#fff" }}
                  />
                </div>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4">
              <div className="enGlobleCatelogueModalListMain">
                <Scrollbars style={{ width: "100%", height: 280 }}>
                  <div className="d-flex align-items-center mb-4">
                    <Form.Check label="1" inline className="enCheckBoxOnly" />
                    <div className="enGlobleCatelogueModalList d-flex align-items-center justify-content-between w-100">
                      <div className="d-flex align-items-center">
                        <div className="enCatelogueIconDiv">
                          <SVG
                            width="27px"
                            src={require("../../../../../../../assets/images/UserManagement/menuicon.svg")}
                          />
                        </div>
                        <div className="f14-500 px-3">Catalogue Menu 1</div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="f14-500 pr-3">ID : #1000-001</div>
                      </div>
                    </div>
                  </div>
                </Scrollbars>
              </div>

              <div className="d-flex align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                >
                  Cancel
                </Button>
                <Button variant="danger" className="btn150px btn-lg px-5">
                  Proceed
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export const DeleteModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.redButton ? (
        <div className="enIconBtn mr-3" onClick={handleShowBlockUser}>
          <Image
            src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
            alt="Delete"
            title="Delete"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          className="enBtnoutlineGrayIcon"
          onClick={handleShowBlockUser}
        >
          <SVG
            src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
          />
        </button>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={handleCloseBlockUser}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

FastFoodMenuSetup.propTypes = {
  auth: PropTypes.object.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  menuCategory: state.onboarding.menuCategory,
});

export default connect(mapStateToProps, { get_category_menu_setup })(
  FastFoodMenuSetup
);
